module.exports = __webpack_public_path__ + "img/gift-codes-blue.2fa9aa9a.svg";